import React, { useEffect, useRef } from 'react';
import QRCode from 'qrcode';
import './mobile-redirect.scss';

interface MobileRedirectProps {
  redirectUrl: string;
  title?: string;
  subtitle?: string;
}

const MobileRedirect: React.FC<MobileRedirectProps> = ({
  redirectUrl,
  title = "Mobile Experience Available",
  subtitle = "Scan the QR code below with your mobile device for the best experience"
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const generateQRCode = async () => {
      if (canvasRef.current) {
        try {
          await QRCode.toCanvas(canvasRef.current, redirectUrl, {
            width: 256,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
        } catch (error) {
          console.error('Error generating QR code:', error);
        }
      }
    };

    generateQRCode();
  }, [redirectUrl]);

  return (
    <div className="mobile-redirect-container">
      <div className="mobile-redirect-content">
        <div className="mobile-redirect-header">
          <div className="logo-container">
            <img 
              src="/Aqary logo.png" 
              alt="Aqary Logo" 
              className="aqary-logo"
              onError={(e) => {
                // Fallback to alternative logo if first one fails
                (e.target as HTMLImageElement).src = "/aqary-logo.png";
              }}
            />
          </div>
          <h2 className="mobile-redirect-title">{title}</h2>
          <p className="mobile-redirect-subtitle">{subtitle}</p>
        </div>
        
        <div className="qr-code-section">
          <canvas
            ref={canvasRef}
            className="qr-code-canvas"
            aria-label={`QR code linking to ${redirectUrl}`}
          />
          <p className="qr-code-instruction">
            Scan with your mobile camera or QR code reader
          </p>
        </div>

        <div className="redirect-options">
          <div className="url-display">
            <code className="mobile-url">{redirectUrl}</code>
          </div>
        </div>

        <div className="mobile-redirect-footer">
          <p className="footer-text">
            This application is optimized for mobile devices. 
            For the best experience, please access it from your smartphone or tablet.
          </p>
          <p className="footer-text" style={{ fontSize: '0.8rem', marginTop: '10px', opacity: 0.7 }}>
            For testing purposes, you can add <code>?bypass=true</code> to the URL to skip this redirect.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MobileRedirect;
